import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/modalDetail.actions'

const initialState = 0

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.MODAL_ADD_ID:
      return action.id
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}